import Button from '@atlaskit/button';
import { B400 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React, { PropsWithChildren } from 'react';

export type CTAButtonProps = {
  highlighted?: boolean;
  disabled?: boolean;
  onClickHandler: () => void;
};

const CTAButton = ({
  highlighted = false,
  disabled = false,
  onClickHandler,
  children
}: PropsWithChildren<CTAButtonProps>) => {
  const style: React.CSSProperties = {
    border: !highlighted && !disabled ? `1px solid ${B400}` : 'none',
    font: 'Charlie Text',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
    height: 'auto',
    textDecoration: 'none',
    width: 'fit-content',
    whiteSpace: 'normal',
    paddingTop: '8px',
    paddingBottom: '8px'
  };

  if (disabled) {
    style.backgroundColor = 'rgba(9, 30, 66, 0.04)';
  }

  return (
    <ButtonWrapper>
      <Button
        appearance={highlighted ? 'primary' : 'link'}
        onClick={() => onClickHandler()}
        isDisabled={disabled}
        style={style}
      >
        {children}
      </Button>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  span {
    white-space: normal;
  }
`;

export { CTAButton };
